<template>
	<AppScreen :scrollable="scrollable">
		<div class="game-wrapper">
			<GameHeader v-if="!$route.meta.hideHeader" />
			<GameSpace ref="gameSpace" />
		</div>
	</AppScreen>
</template>

<script>
import AppScreen from '@/components/partials/AppScreen';
import GameSpace from '@/components/views/game/GameSpace';
import GameHeader from '@/components/views/game/GameHeader';

export default {
	name: 'Game',
	components: {
		AppScreen,
		GameSpace,
		GameHeader,
	},
	computed: {
		scrollable() {
			return typeof this.$route.meta.scrollable !== "undefined" ? this.$route.meta.scrollable : false;
		},
	},
};
</script>

<style lang="scss" scoped>
	.game-wrapper {
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
	}

	.info-panel {
		z-index: $z-mid;
	}
</style>
